module.exports = __webpack_public_path__ + "static/img/web_pg_ca.e0abbcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_pg_ca.png
// module id = PCUT
// module chunks = 1